import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage
} from "@watt/ui/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@watt/ui/components/ui/radio-group";
import type * as z from "zod";
import AutoFormLabel from "../common/label";
import AutoFormTooltip from "../common/tooltip";
import type { AutoFormInputComponentProps } from "../utils/types";
import { getBaseSchema } from "../utils/utils";

export default function AutoFormRadioGroup({
  label,
  isRequired,
  field,
  zodItem,
  fieldProps,
  fieldConfigItem
}: AutoFormInputComponentProps) {
  // biome-ignore lint/suspicious/noExplicitAny: <fix later>
  const baseValues = (getBaseSchema(zodItem) as unknown as z.ZodEnum<any>)._def
    .values;

  let values: string[] = [];
  if (!Array.isArray(baseValues)) {
    values = Object.entries(baseValues).map(item => item[0]);
  } else {
    values = baseValues;
  }

  return (
    <div>
      <FormItem>
        <AutoFormLabel
          isRequired={isRequired}
          label={fieldConfigItem?.label || label}
        />
        <FormControl>
          <RadioGroup
            defaultValue={field.value}
            onValueChange={field.onChange}
            {...fieldProps}
          >
            {/* biome-ignore lint/suspicious/noExplicitAny: <fix later> */}
            {values?.map((value: any) => (
              <FormItem
                className="mb-2 flex items-center gap-3 space-y-0"
                key={value}
              >
                <FormControl>
                  <RadioGroupItem value={value} />
                </FormControl>
                <FormLabel className="font-normal">{value}</FormLabel>
              </FormItem>
            ))}
          </RadioGroup>
        </FormControl>
        <FormMessage />
      </FormItem>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />
    </div>
  );
}
